module.exports = __webpack_public_path__ + "media/images/proof_links/colored/kinopoisk-e6ef7cf9e65750367b548a80a33263d3.svg";